// components/Contact/Contact.js
import React, { useState } from 'react';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    mobile: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      first_name: formData.first_name.trim(),
      last_name: formData.last_name.trim(),
      email: formData.email.trim(),
      mobile: formData.mobile.trim(),
      message: formData.message.trim()
    };

    try {
      const response = await fetch('https://zyve-backend.onrender.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error('Failed to submit form');
      }

      alert('Form submitted successfully!');
      setFormData({
        first_name: '',
        last_name: '',
        email: '',
        mobile: '',
        message: ''
      });
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('An error occurred. Please try again later.');
    }
  };

  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <div className="contact-left">
          <h2>Contact Us</h2>
          <p>Interested in working together? Fill out some info and we will be in touch shortly. We can't wait to hear from you!</p>
        </div>

        <div className="contact-right">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Name*</label>
              <div className="name-fields">
                <input 
                  type="text" 
                  name="first_name" 
                  placeholder="First Name*" 
                  value={formData.first_name} 
                  onChange={handleChange} 
                  required 
                />
                <input 
                  type="text" 
                  name="last_name" 
                  placeholder="Last Name" 
                  value={formData.last_name} 
                  onChange={handleChange} 
                />
              </div>
            </div>

            <div className="form-group">
              <label>Email ID*</label>
              <input 
                type="email" 
                name="email" 
                placeholder="Email*" 
                value={formData.email} 
                onChange={handleChange} 
                required 
              />
            </div>

            <div className="form-group">
              <label>Mobile No*</label>
              <input 
                type="text" 
                name="mobile" 
                placeholder="Mobile Number*" 
                value={formData.mobile} 
                onChange={handleChange} 
                required 
              />
            </div>

            <div className="form-group">
              <label>Message*</label>
              <textarea 
                name="message" 
                rows="6" 
                placeholder="Write your message here*" 
                value={formData.message} 
                onChange={handleChange} 
                required 
              />
            </div>

            <button type="submit" className="submit-btn">Send</button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact;